import React from 'react'
import { FiMapPin } from 'react-icons/fi'
import { SearchTab } from 'types'
import { Flex, Center, useColorModeValue, Text } from '@chakra-ui/react'

type SuggestionItemProps = SearchTab & { onClick?: (items: SearchTab) => void }

const SuggestionItem: React.FC<SuggestionItemProps> = ({
  _key,
  name,
  id,
  typename,
  province,
  district,
  city,
  tab,
  slug,
  onClick
}) => {
  const hoverBg = useColorModeValue('gray.50', 'gray.600')
  return (
    <Flex
      onClick={() => {
        if (onClick) onClick({ name, _key, id, typename, province, city, tab, slug, district })
      }}
      _hover={{ bg: hoverBg }}
      align="center"
      cursor="pointer"
      key={_key}
      p={4}
      justify="space-between"
    >
      <Center>
        <Center mx={2}>
          <FiMapPin size={14} />
        </Center>
        <Text fontSize="xs">
          {name}
          {city && `, ${city.name}`}
          {province && `, ${province.name}`}
        </Text>
      </Center>
      <Text fontSize="xs" color="gray.400">
        {typename}
      </Text>
    </Flex>
  )
}

export default SuggestionItem
